var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g3, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPollyTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z",
    fill: "#FAAB35"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7027_469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z",
    fill: "#FAAB35"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7027_469)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7027_469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 34,
    width: 17,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3506 45.1329C34.7419 44.8783 34.36 44.7189 34.36 44.7189C31.9419 43.4389 32.3687 37.4647 32.3687 37.4647C32.3687 37.4647 29.7977 35.5055 27.7291 34.3664V34.2681C27.6995 34.2836 27.6699 34.3012 27.6403 34.3172C27.6104 34.3012 27.581 34.2836 27.5512 34.2681V34.3664C25.4825 35.5055 22.9116 37.4647 22.9116 37.4647C22.9116 37.4647 23.3384 43.4391 20.9202 44.7189C20.9202 44.7189 20.5386 44.8783 19.9297 45.1329C21.3458 48.2528 24.2622 50.3997 27.6403 50.3997C31.0183 50.3997 33.9348 48.2528 35.3506 45.1329Z",
    fill: "#A06A4B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7027_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3613 45.1329C37.7526 44.8783 37.3708 44.7189 37.3708 44.7189C34.9526 43.4389 35.3794 37.4647 35.3794 37.4647C35.3794 37.4647 32.8085 35.5055 30.7398 34.3664V34.2681C30.7102 34.2836 30.6806 34.3012 30.651 34.3172C30.6211 34.3012 30.5918 34.2836 30.5619 34.2681V34.3664C28.4933 35.5055 25.9223 37.4647 25.9223 37.4647C25.9223 37.4647 26.3491 43.4391 23.931 44.7189C23.931 44.7189 23.5494 44.8783 22.9404 45.1329C24.3565 48.2528 27.2729 50.3997 30.651 50.3997C34.0291 50.3997 36.9455 48.2528 38.3613 45.1329Z",
    fill: "#A06A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7218 39.7004C33.7218 39.7004 28.6544 45.8345 19.5333 44.7677C16.7077 44.4373 21.738 36.3037 21.738 36.3037L32.4678 37.4415L33.7218 39.7004Z",
    fill: "#764D34"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1688 45.9678H35.1812C35.1812 48.1325 31.8134 49.8873 27.659 49.8873C23.5044 49.8873 20.1364 48.1325 20.1364 45.9678H18.0738C18.0738 45.9678 10.4891 48.0163 10.7538 48.9898C12.47 55.3049 19.3867 60.0283 27.659 60.0283C35.8696 60.0283 42.7447 55.3752 44.5248 49.1308C44.8149 48.1142 37.1688 45.9678 37.1688 45.9678Z",
    fill: "#A2DADD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7641 41.0337C22.7641 41.0337 18.1074 41.4283 18.1074 45.9676C18.1074 50.5068 23.3707 53.1565 27.629 52.9912C28.816 52.9453 28.332 47.8425 28.332 47.8425C28.332 47.8425 21.8822 48.5734 22.7641 41.0337Z",
    fill: "#26ACAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5163 41.0337C32.5163 41.0337 37.173 41.4283 37.173 45.9676C37.173 50.5068 31.8871 53.1565 27.6288 52.9912C26.4413 52.9453 26.9484 47.8425 26.9484 47.8425C26.9484 47.8425 33.3982 48.5734 32.5163 41.0337Z",
    fill: "#26ACAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8568 18.4351C31.8065 18.4351 30.1445 16.7729 30.1445 14.7225C30.1445 12.6725 31.8065 11.0103 33.8568 11.0103C35.9071 11.0103 37.5691 12.6725 37.5691 14.7225C37.5691 16.7729 35.9071 18.4351 33.8568 18.4351Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6689 17.4917C25.1956 17.4917 23.1904 15.4865 23.1904 13.0132C23.1904 10.5398 25.1956 8.53467 27.6689 8.53467C30.1423 8.53467 32.1475 10.5398 32.1475 13.0132C32.1475 15.4865 30.1423 17.4917 27.6689 17.4917Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5171 21.5808C35.7796 21.5808 34.3711 20.1723 34.3711 18.4348C34.3711 16.6971 35.7796 15.2886 37.5171 15.2886C39.2546 15.2886 40.6631 16.6971 40.6631 18.4348C40.6631 20.1723 39.2546 21.5808 37.5171 21.5808Z",
    fill: "#231F20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5696 25.9998C35.8321 25.9998 34.4238 24.5912 34.4238 22.8538C34.4238 21.1161 35.8321 19.7075 37.5696 19.7075C39.3073 19.7075 40.7156 21.1161 40.7156 22.8538C40.7156 24.5912 39.3073 25.9998 37.5696 25.9998Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1655 30.2952C34.4281 30.2952 33.0195 28.8867 33.0195 27.1492C33.0195 25.4115 34.4281 24.0029 36.1655 24.0029C37.903 24.0029 39.3115 25.4115 39.3115 27.1492C39.3115 28.8867 37.903 30.2952 36.1655 30.2952Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4232 18.4351C23.4735 18.4351 25.1355 16.7729 25.1355 14.7225C25.1355 12.6725 23.4735 11.0103 21.4232 11.0103C19.3729 11.0103 17.7109 12.6725 17.7109 14.7225C17.7109 16.7729 19.3729 18.4351 21.4232 18.4351Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7632 21.5808C19.5006 21.5808 20.9092 20.1723 20.9092 18.4348C20.9092 16.6971 19.5006 15.2886 17.7632 15.2886C16.0257 15.2886 14.6172 16.6971 14.6172 18.4348C14.6172 20.1723 16.0257 21.5808 17.7632 21.5808Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7105 25.9998C19.4479 25.9998 20.8565 24.5912 20.8565 22.8538C20.8565 21.1161 19.4479 19.7075 17.7105 19.7075C15.973 19.7075 14.5645 21.1161 14.5645 22.8538C14.5642 24.5912 15.9727 25.9998 17.7105 25.9998Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1147 30.2952C20.8522 30.2952 22.2607 28.8867 22.2607 27.1492C22.2607 25.4115 20.8522 24.0029 19.1147 24.0029C17.3773 24.0029 15.9688 25.4115 15.9688 27.1492C15.9688 28.8867 17.3773 30.2952 19.1147 30.2952Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7027_469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 15,
    width: 21,
    height: 27
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7981 20.7918C35.3758 15.8845 30.255 15.3867 28.1214 15.3867H27.5189H26.9163C24.7827 15.3867 19.6621 15.8845 18.2398 20.7918C16.8232 25.6783 16.354 41.2685 27.5189 41.2685C38.6859 41.2685 38.2144 25.6783 36.7981 20.7918Z",
    fill: "#A06A4B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7027_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7981 20.7918C35.3758 15.8845 30.255 15.3867 28.1214 15.3867H27.5189H26.9163C24.7827 15.3867 19.6621 15.8845 18.2398 20.7918C16.8232 25.6783 16.354 41.2685 27.5189 41.2685C38.6859 41.2685 38.2144 25.6783 36.7981 20.7918Z",
    fill: "#A06A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5449 18.4893C30.5449 18.4893 37.6227 23.4678 34.0271 27.6826C31.2055 30.9904 34.0271 31.1488 34.0271 31.1488C34.0271 31.1488 34.845 37.2651 33.4937 39.2565C38.969 38.9682 55.4442 20.0087 30.5449 18.4893Z",
    fill: "#764D34"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7268 36.8552C24.2398 36.8552 26.2768 34.8018 26.2768 32.2688C26.2768 29.736 24.2398 27.6826 21.7268 27.6826C19.2138 27.6826 17.1768 29.736 17.1768 32.2688C17.1768 34.8018 19.2138 36.8552 21.7268 36.8552Z",
    fill: "#A06A4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4946 36.8552C36.0076 36.8552 38.0446 34.8018 38.0446 32.2688C38.0446 29.736 36.0076 27.6826 33.4946 27.6826C30.9814 27.6826 28.9443 29.736 28.9443 32.2688C28.9443 34.8018 30.9814 36.8552 33.4946 36.8552Z",
    fill: "#A06A4B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3756 30.0465C37.3756 30.0465 37.4042 18.1508 27.8546 18.1508C18.3044 18.1508 23.0795 17.0671 23.0795 17.0671L27.5512 13.9555C27.5512 13.9555 41.8642 12.5332 37.3756 30.0465Z",
    fill: "#F47C24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7336 30.0465C17.7336 30.0465 17.705 18.1508 27.2549 18.1508C31.3809 18.1508 32.2317 18.2745 32.03 17.0671C31.7324 15.289 27.5582 13.9555 27.5582 13.9555C27.5582 13.9555 13.2453 12.5332 17.7336 30.0465Z",
    fill: "#FAAB35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0279 32.2693C21.0416 32.2693 21.8635 31.4473 21.8635 30.4337C21.8635 29.4201 21.0416 28.5981 20.0279 28.5981C19.0143 28.5981 18.1924 29.4201 18.1924 30.4337C18.1924 31.4473 19.0143 32.2693 20.0279 32.2693Z",
    fill: "#AF8065"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.015 32.2693C36.0286 32.2693 36.8506 31.4473 36.8506 30.4337C36.8506 29.4201 36.0286 28.5981 35.015 28.5981C34.0016 28.5981 33.1797 29.4201 33.1797 30.4337C33.1797 31.4473 34.0016 32.2693 35.015 32.2693Z",
    fill: "#AF8065"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9698 29.309C24.3464 29.309 24.6515 28.5809 24.6515 27.6827C24.6515 26.7845 24.3464 26.0562 23.9698 26.0562C23.5932 26.0562 23.2881 26.7845 23.2881 27.6827C23.2881 28.5809 23.5932 29.309 23.9698 29.309Z",
    fill: "#231F20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2513 27.5103C32.0375 26.9744 31.598 26.6025 31.0846 26.6025C30.5713 26.6025 30.1317 26.9744 29.918 27.5103C30.27 27.4024 30.6654 27.3399 31.0846 27.3399C31.5041 27.3402 31.8993 27.4026 32.2513 27.5103Z",
    fill: "#231F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.392 25.2606C25.0001 24.6742 24.4462 24.3062 23.83 24.3062C22.8645 24.3062 22.0478 25.2049 21.7764 26.4423C22.3073 25.6018 23.2326 25.0435 24.2878 25.0435C24.6782 25.0435 25.0498 25.1218 25.392 25.2606Z",
    fill: "#231F20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1475 23.6955C30.6352 23.186 31.2449 22.9197 31.8516 23.0269C32.8022 23.1945 33.4505 24.2214 33.503 25.4872C33.1261 24.5671 32.3119 23.8566 31.2727 23.6734C30.8881 23.6057 30.5083 23.6182 30.1475 23.6955Z",
    fill: "#231F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2812 36.7781C27.2812 36.7781 29.8113 38.0581 31.4579 35.9629C31.4579 35.9629 30.8814 37.4128 29.7373 37.6848C28.2412 38.0406 27.2812 36.7781 27.2812 36.7781Z",
    fill: "#764D34"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9844 27.6826C27.9844 27.6826 29.3048 30.9726 29.2379 31.4333C28.7757 32.269 27.9844 32.269 27.9844 32.269C27.9844 32.269 28.3991 31.4501 28.3489 30.8286C28.3115 30.3697 27.9844 27.6826 27.9844 27.6826Z",
    fill: "#764D34"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1048 36.5663C29.601 36.5663 30.0035 36.0517 30.0035 35.4172C30.0035 34.7826 29.601 34.2681 29.1048 34.2681C28.6085 34.2681 28.2061 34.7826 28.2061 35.4172C28.2061 36.0517 28.6085 36.5663 29.1048 36.5663Z",
    fill: "#764D34"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7027_469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 36,
    width: 13,
    height: 12
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5675 47.8515C23.6432 47.8515 26.1369 45.3581 26.1369 42.2821C26.1369 39.2063 23.6432 36.7129 20.5675 36.7129C17.4917 36.7129 14.998 39.2063 14.998 42.2821C14.998 45.3581 17.4917 47.8515 20.5675 47.8515Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7027_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5675 47.8515C23.6432 47.8515 26.1369 45.3581 26.1369 42.2821C26.1369 39.2063 23.6432 36.7129 20.5675 36.7129C17.4917 36.7129 14.998 39.2063 14.998 42.2821C14.998 45.3581 17.4917 47.8515 20.5675 47.8515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.974 49.2416L27.9463 64.2139L42.9186 49.2416L27.9463 34.2693L12.974 49.2416Z",
    fill: "#D1D3D4"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5379 47.8351C23.6137 47.8351 26.1071 45.3417 26.1071 42.2659C26.1071 39.1902 23.6137 36.6968 20.5379 36.6968C17.4621 36.6968 14.9688 39.1902 14.9688 42.2659C14.9688 45.3417 17.4621 47.8351 20.5379 47.8351Z",
    stroke: "#231F20",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4965 43.9235C21.5706 43.9235 22.4412 43.088 22.4412 42.0573C22.4412 41.0267 21.5706 40.1909 20.4965 40.1909C19.4224 40.1909 18.5518 41.0267 18.5518 42.0573C18.5518 43.088 19.4221 43.9235 20.4965 43.9235Z",
    fill: "#F47C24"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4971 38.7427V42.057",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2261 44.3574L20.4971 42.0571",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6482 34.7148C19.6482 34.7148 18.8955 34.7148 18.8955 35.4675V36.1026C18.8955 36.1026 18.8955 36.8552 19.6482 36.8552H21.3455C21.3455 36.8552 22.0982 36.8552 22.0982 36.1026V35.4675C22.0982 35.4675 22.0982 34.7148 21.3455 34.7148H19.6482Z",
    fill: "#231F20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollyTime);
export default __webpack_public_path__ + "static/media/pollyTime.9d183ad9.svg";
export { ForwardRef as ReactComponent };